/** Bump with the persisted shape, and add the matching `MIGRATIONS[N]` entry. */
export const SCHEMA_VERSION = 23;
